import { createSlice, PayloadAction, WritableDraft } from "@reduxjs/toolkit";

export enum ModalType {
  Auth = "auth",
  NewFirm = "newFirm",
}

export enum AuthTab {
  Login = "login",
  Register = "register",
}

export interface AuthModalParams {
  defaultTab?: AuthTab;

  defaultUsername?: string;
  defaultPassword?: string;
}

export type ModalParams = {
  [ModalType.Auth]: AuthModalParams | null;
  [ModalType.NewFirm]: Record<string, never> | null;
};

interface ModalState {
  activeModal: ModalType | null;
  params: ModalParams;
}

const initialState: ModalState = {
  activeModal: null,
  params: {
    auth: { defaultTab: AuthTab.Login },
    newFirm: null,
  },
};

const modalSlice = createSlice({
  name: "modal",
  initialState,
  reducers: {
    openModal: <M extends ModalType>(
      state: WritableDraft<ModalState>,
      action: PayloadAction<{
        modal: M | null;
        params?: ModalParams[M];
      }>
    ) => {
      state.activeModal = action.payload.modal;
      const newParams = state.params;
      if (action.payload.modal)
        newParams[action.payload.modal] = action.payload.params || null;
      state.params = newParams;
    },
    closeModal: (state) => {
      state.activeModal = null;
      state.params = {
        auth: null,
        newFirm: null,
      };
    },
  },
});

export const { openModal, closeModal } = modalSlice.actions;

export const selectActiveModal = (state: { modal: ModalState }) =>
  state.modal.activeModal;
export const selectModalParams = (state: { modal: ModalState }) =>
  state.modal.params;
export const watchModal =
  (modal: ModalType) => (state: { modal: ModalState }) =>
    state.modal.activeModal === modal;

export default modalSlice.reducer;
